export const parseQuery = (search: string) => {
  const q: Record<string, string> = {}
  
  search.substring(1).split("&").forEach(sq => {
    let a = sq.split('=')
    q[a[0]] = a[1]
  })
  return q
}